import React from "react";
import lazyPage from "../../../../common/helpers/lazyPage";
import LoadingFrame from "../../LoadingFrame";

export default lazyPage(
    "src/front/components/Score/score-display/ScoreDisplay.tsx",
    () => import("./ScoreDisplay"),
    <LoadingFrame />,
);
